import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import React, { useLayoutEffect, useState } from 'react';
import {
  createRippleEffectRelative,
  getScreenName,
} from '../../../Utils/helper';
import { assessmentText } from '../../QnaPage/AssessmentStrip/instrumentation';
import {
  PopupInput,
  RadioInputSection,
  RadioLabel,
  RadioOption,
} from '../HealthPlan/styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function RadioInputField(props) {
  const {
    element,
    inputFieldErrorHandler,
    index,
    showNewUI,
    currentQuestionAnswer,
    inAppForm,
  } = props;
  const [activeIndex, setActiveIndex] = useState();

  const optionClick = (e, idx) => {
    const ele = document.getElementById(index + 'radio' + idx);
    setActiveIndex(idx);
    createRippleEffectRelative(e, ele);
  };
  const eventHandler = (value) => {
    if (!inAppForm)
      fireEvent({
        category: 'entered_data',
        screen_name: getScreenName(),
        sku_type: assessmentText,
        page_url: typeof window != 'undefined' ? window.location.href : 'NA',
        parent: assessmentText,
        name: element?.question_text,
        value: value,
      });
  };
  useLayoutEffect(() => {
    element?.options.map((item, i) => {
      item === currentQuestionAnswer ? setActiveIndex(i) : null;
    });
    gsap.registerPlugin(ScrollTrigger);
    const mainTimeline = gsap.timeline({
      ease: 'bounce.out',
    });
    const arr = gsap.utils.toArray('.radioOptions');
    const heading = document.querySelector('h2');
    const anim = gsap.from(
      arr,
      {
        transform: 'translate(300px,0px)',
        webkitTransform: 'translate(300px,0px)',
        autoAlpha: 0,
        stagger: 0.1,
        duration: 0.4,
      },
      '<',
    );
    const headingAnim = gsap.from(heading, {
      autoAlpha: 0,
      duration: 0.4,
    });
    // mainTimeline.add(headingAnim);
    mainTimeline.add(anim);
  }, [element]);
  return (
    <RadioInputSection showNewUI={showNewUI}>
      <h2>{element?.question_text}</h2>
      {element?.description && <p>{element?.description}</p>}

      {element?.options.map((item, i) => {
        return (
          <RadioOption
            onClick={(e) => optionClick(e, i)}
            id={index + 'radio' + i}
            showNewUI={showNewUI}
            key={`index_${i}`}
            className="radioOptions"
            activeIndex={activeIndex == i}
          >
            <PopupInput
              type="radio"
              id={'radio' + i}
              name="radio"
              value={item}
              onChange={(event) => {
                inputFieldErrorHandler(event.target.value, index);
                eventHandler(event.target.value);
              }}
              defaultChecked={
                currentQuestionAnswer == item ||
                currentQuestionAnswer == item?.trim()
              }
              required={element?.required == 1 ? true : false}
            />
            <RadioLabel showNewUI={showNewUI} for={'radio' + i}>
              {item}
            </RadioLabel>
          </RadioOption>
        );
      })}
    </RadioInputSection>
  );
}
